import { http } from '@/http';

export default {
  namespaced: true,

  state: {
    // Mensagens são armazenadas por tipo de chat
    floatingMessages: [],
    floatingLoading: false,
    selectedChatUser: null,
    conversationId: null,
    conversationTitle: null,
  },

  getters: {
    getFloatingMessages: state => state.floatingMessages,
    isFloatingLoading: state => state.floatingLoading,
  },

  mutations: {
    ADD_FLOATING_MESSAGE(state, payload) {
      state.floatingMessages.push({
        // id: `msg_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
        // timestamp: new Date(),
        text: payload.text,
        sender: payload.sender, // 'user' ou 'ai'
        ...payload
      });
    },

    CLEAR_FLOATING_MESSAGES(state) {
      state.floatingMessages = [];
    },

    SET_FLOATING_LOADING(state, loading) {
      state.floatingLoading = loading;
    },

    SET_SELECTED_CHAT_USER(state, user) {
      state.selectedChatUser = user;
    },

    SET_CONVERSATION_ID(state, conversationId) {
      state.conversationId = conversationId;
    },

    SET_CONVERSATION_TITLE(state, title) {
      state.conversationTitle = title;
    },
  },

  actions: {
    /**
     * Envia mensagem e obtém resposta da IA
     */
    async sendFloatingMessage({ commit, state, dispatch }, message) {
      try {
        const isFirstMessage = state.floatingMessages.length === 0;

        // Adiciona mensagem do usuário
        commit('ADD_FLOATING_MESSAGE', {
          text: message,
          sender: 'user'
        });

        // Ativa loading
        commit('SET_FLOATING_LOADING', true);

        // Chamada à API de IA - Usa conversation_id existente ou null para nova conversa
        const response = await http.post('/api/ai-chat/chat', {
          message: message,
          conversation_id: state.conversationId
        });

        // Atualiza conversation_id se for a primeira mensagem
        if (response.data.conversation_id && !state.conversationId) {
          commit('SET_CONVERSATION_ID', response.data.conversation_id);
                    
          // Se for a primeira mensagem, define o título automaticamente
          if (isFirstMessage) {
            // Usa a mensagem como título, truncando para o limite da API de 200 caracteres
            const chatTitle = message.trim().substring(0, 200);
                        
            // Atualiza o título via API (título completo)
            try {
              await dispatch('updateConversationTitle', {
                conversationId: response.data.conversation_id,
                title: chatTitle
              });
              commit('SET_CONVERSATION_TITLE', chatTitle);
            } catch (error) {
              console.error('Erro ao definir título automático:', error);
            }
          }
        }

        // Extrai resposta da IA
        let aiResponse = 'Desculpe, não consegui processar sua mensagem.';
        let aiMessageId = null;
        let aiAgentId = null;

        if (response.data && response.data.message && response.data.message.content) {
          aiResponse = response.data.message.content;
          aiMessageId = response.data.message.id || null;
          aiAgentId = response.data.message.metadata?.agent_type || response.data.metadata?.agent_type || null;
        } else if (response.data && response.data.message && typeof response.data.message === 'string') {
          aiResponse = response.data.message;
          aiAgentId = response.data.metadata?.agent_type || null;
        } else if (response.data && response.data.response) {
          aiResponse = response.data.response;
          aiAgentId = response.data.metadata?.agent_type || null;
        } else if (response.data && response.data.text) {
          aiResponse = response.data.text;
          aiAgentId = response.data.metadata?.agent_type || null;
        }

        // Adiciona resposta da IA
        commit('ADD_FLOATING_MESSAGE', {
          text: aiResponse,
          sender: 'ai',
          id: aiMessageId,
          agent_id: aiAgentId
        });

        return aiResponse;
      } catch (error) {
        console.error('Erro ao enviar mensagem:', error);
        
        // Fallback: resposta genérica de erro
        const errorMessage = 'Desculpe, está ocorrendo um erro ao processar sua mensagem. Tente novamente.';
        commit('ADD_FLOATING_MESSAGE', {
          text: errorMessage,
          sender: 'ai'
        });
        
        throw error;
      } finally {
        commit('SET_FLOATING_LOADING', false);
      }
    },

    /**
     * Atualiza o título da conversa
     */
    async updateConversationTitle({ commit }, { conversationId, title }) {
      try {
        const truncatedTitle = title.trim().substring(0, 200); // Trunca o título para o limite da API de 200 caracteres
        const response = await http.put(`/api/ai-chat/conversations/${conversationId}`, {
          title: truncatedTitle
        });
        
        if (response.data && response.data.title) {
          commit('SET_CONVERSATION_TITLE', response.data.title);
        }
        
        return response.data;
      } catch (error) {
        console.error('Erro ao atualizar título da conversa:', error);
        throw error;
      }
    },

    /**
     * Limpa histórico de mensagens
     */
    clearFloatingMessages({ commit }) {
      commit('CLEAR_FLOATING_MESSAGES');
      commit('SET_CONVERSATION_ID', null);
      commit('SET_CONVERSATION_TITLE', null);
    },

    /**
     * Define usuário selecionado no chat (para sincronização com ChatMessages)
     */
    setSelectedChatUser({ commit }, user) {
      commit('SET_SELECTED_CHAT_USER', user);
    },
  },
};
